<script lang="ts">
	import type { OperationModel } from '../../../models/api/OperationModel';
	import type { TabsProps } from '$lib/types/props';
	import { t } from 'svelte-i18n';
	import { urls } from '../../../urls';
	import { goto } from '$app/navigation';
	import { undefOrNull } from '$lib/utils/objects';
	import Tabs from '$lib/components/Tabs.svelte';
	import { getDynamicTabs } from '../../../utils/operations';
	import ProjectIndex from '../../../components/projects/ProjectIndex.svelte';

	export let operation: OperationModel;
	export let slug: string = null;

	let tabs: TabsProps = [
		{
			key: 'index',
			title: {
				label: $t('operation.tabs.clubDeal') as string,
				onClick: () => {
					goto(urls.PROJECT.INDEX(operation.id.toString()), { noScroll: true });
				}
			},
			pane: {
				type: 'component'
			}
		},
		{
			key: 'details',
			title: {
				label: $t('operation.tabs.assembly') as string,
				onClick: () => {
					goto(urls.PROJECT.DETAILS(operation.id.toString()), { noScroll: true });
				}
			},
			pane: {
				type: 'component'
			}
		}
	];

	operation.gestionnaireProjet &&
		tabs.push({
			key: 'partenaire',
			title: {
				label: $t('operation.tabs.partner') as string,
				onClick: () => {
					goto(urls.PROJECT.PARTNER(operation.id.toString()), { noScroll: true });
				}
			},
			pane: {
				type: 'component'
			}
		});

	tabs.push(...getDynamicTabs(operation));

	$: currentTabIndex = undefOrNull(slug) ? 0 : tabs.findIndex((e) => e.key === slug);

	const getTabContent = async (slug: string, operation: OperationModel) => {
		let component;

		switch (slug) {
			case 'details':
				component = (
					await import('../../../components/projects/tabs/content/clubdeal/ClubDealDetails.svelte')
				).default;
				break;
			case 'news':
				component = (await import('../../../components/projects/ProjectNews.svelte')).default;
				break;
			case 'questions':
				component = (await import('../../../components/projects/ProjectQuestions.svelte')).default;
				break;
			case 'temoignages':
				component = (await import('../../../components/projects/ProjectTestimonies.svelte'))
					.default;
				break;
			case 'lives':
				component = (await import('../../../components/projects/ProjectLives.svelte')).default;
				break;
			case 'partenaire':
				component = (await import('./content/clubdeal/ClubDealPartner.svelte')).default;
				break;
			default:
				component = ProjectIndex;
		}

		if (currentTabIndex !== -1) {
			tabs[currentTabIndex].pane.content = {
				component,
				props: { operation }
			};
			tabs = tabs;
		}
	};

	$: getTabContent(slug, operation);
</script>

<Tabs {tabs} activeTab={currentTabIndex} sticky />
